{
  "moduleTitle": "Choisir un module",
  "detailsTitle": "Détails de l'assignation",
  "continue": "Continuer",
  "assign": "Assigner le module",
  "assigning": "Assignation",
  "missingContext": "Des informations nécessaires pour assigner ce module sont manquantes. Veuillez actualiser la page et réessayer.",
  "retry": "Réessayer",
  "emptyTitle": "Aucun module pour l'instant",
  "emptyMessage": "Créez un module de formation avant d'en assigner un.",
  "alreadyAssigned": "Déjà assigné",
  "reassignWarning": "Assigner ce module à nouveau effacera la progression actuelle de {{person}}.",
  "dueDate": "Date d'échéance",
  "notify": "M'avertir quand {{person}} termine ce module"
}
